import { useEffect } from 'react';

const SEOHead = ({ 
  title = "Chronaxis - Gestion d'Emplois du Temps Universitaires",
  description = "Plateforme de gestion d'emplois du temps pour universités et établissements d'enseignement supérieur en Tunisie",
  keywords = "emploi du temps, université, planification, cours, enseignants, salles, Tunisie, éducation",
  canonical = "https://chronaxis.tn"
}) => {
  useEffect(() => {
    // Update title
    document.title = title;
    
    // Update meta tags
    const updateMeta = (name, content) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };
    
    updateMeta('description', description);
    updateMeta('keywords', keywords);
    
    // Update canonical
    let canonical_link = document.querySelector('link[rel="canonical"]');
    if (!canonical_link) {
      canonical_link = document.createElement('link');
      canonical_link.rel = 'canonical';
      document.head.appendChild(canonical_link);
    }
    canonical_link.href = canonical;
    
  }, [title, description, keywords, canonical]);

  return null;
};

export default SEOHead;